module.exports = __webpack_public_path__ + "static/img/dLogo.07ed233.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/dLogo.png
// module id = kMYp
// module chunks = 1